// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleDateline_root__2IUdE","link":"ArticleDateline_link__1N8LO","ideasRoot":"ArticleDateline_ideasRoot__2-P6v"};